import { compose, connectWithHammock, ENDPOINTS } from 'hammock';
import React, { useEffect } from 'react';
import { Subhead } from 'styleguide';

import { ContentMetadata } from '@candu-ai/content/types';
import { useEventing } from 'commons/eventing';

import ContentEmbedTable from './components/ContentEmbedTable';

type ParentDocument = {
  matchMetadata: {
    embeddedContentId: string;
  };
};

interface EmbedsProps {
  parentDocuments: ParentDocument[];
  contentMetadataArray: ContentMetadata[];
  content: ContentMetadata;
}

const EmbedsPageImpl = ({ parentDocuments, content, contentMetadataArray }: EmbedsProps) => {
  const eventing = useEventing();
  useEffect(() => {
    eventing.page(`dashboard.editor.placementsAndEmbeds.embeds`);
  }, []);
  const { id: childContentId } = content;

  const filteredDocuments = parentDocuments.filter(
    (potentialParentDocument) =>
      potentialParentDocument.matchMetadata.embeddedContentId === childContentId,
  );
  return (
    <React.Fragment>
      {filteredDocuments.length > 0 && (
        <Subhead>This piece of content is embedded in the following documents</Subhead>
      )}
      <ContentEmbedTable
        parentDocuments={filteredDocuments}
        contentMetadata={contentMetadataArray}
      />
    </React.Fragment>
  );
};

const withContentMetadata = connectWithHammock({
  endpoint: ENDPOINTS.contentMetadata,
  resourceName: 'contentMetadataArray',
});

const withParentDocuments = connectWithHammock({
  endpoint: ENDPOINTS.contentQuery,
  query: {
    finder: 'byEmbedDocuments',
  },
  resourceName: 'parentDocuments',
});

export const EmbedsPage = compose(withParentDocuments, withContentMetadata)(EmbedsPageImpl);
